/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ (() => {

// Lazy load init
var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});
lazyLoadInstance.update();

//Header shop menu toggle
document.addEventListener('DOMContentLoaded', function () {
  var shopMenuInit = document.querySelector('.init-shop-menu');
  var shopMenuContainer = document.querySelector('.shop-menu');
  var header = document.querySelector('header.header');
  if (!shopMenuInit || !shopMenuContainer || !header) return;

  // Function to show the menu
  function showMenu() {
    header.classList.add('shadow-menu-shadow');
    shopMenuContainer.classList.remove('hidden');
    shopMenuInit.classList.add('bg-blue-shade');
    shopMenuInit.classList.remove('bg-primary-grin');
  }

  // Function to hide the menu
  function hideMenu() {
    header.classList.remove('shadow-menu-shadow');
    shopMenuContainer.classList.add('hidden');
    shopMenuInit.classList.remove('bg-blue-shade');
    shopMenuInit.classList.add('bg-primary-grin');
  }
  function handleResize() {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      shopMenuInit.href = '/collections/all';
      shopMenuInit.addEventListener('mouseenter', showMenu);
      shopMenuContainer.addEventListener('mouseenter', showMenu);
      shopMenuInit.addEventListener('mouseleave', function () {
        setTimeout(function () {
          if (!shopMenuContainer.matches(':hover')) {
            hideMenu();
          }
        }, 50);
      });
      shopMenuContainer.addEventListener('mouseleave', hideMenu);

      // Remove click event if exists
      shopMenuInit.removeEventListener('click', toggleMenu);
    } else {
      shopMenuInit.href = 'javascript:void(0)';

      // Click event for mobile devices
      shopMenuInit.addEventListener('click', toggleMenu);

      // Remove mouse events if exist
      shopMenuInit.removeEventListener('mouseenter', showMenu);
      shopMenuContainer.removeEventListener('mouseenter', showMenu);
      shopMenuInit.removeEventListener('mouseleave', hideMenu);
      shopMenuContainer.removeEventListener('mouseleave', hideMenu);
    }
  }
  function toggleMenu() {
    if (shopMenuContainer.classList.contains('hidden')) {
      showMenu();
      if (!window.matchMedia('(min-width: 1024px)').matches) {
        document.body.classList.add('overflow-hidden');
      }
    } else {
      hideMenu();
      if (!window.matchMedia('(min-width: 1024px)').matches) {
        document.body.classList.remove('overflow-hidden');
      }
    }
  }
  handleResize(); // Initial check

  window.addEventListener('resize', handleResize);

  // Click outside to close the menu
  document.addEventListener('click', function (event) {
    if (!shopMenuContainer.classList.contains('hidden') && !shopMenuContainer.contains(event.target) && !shopMenuInit.contains(event.target)) {
      hideMenu();
    }
  });
  var infoBarHeight = document.querySelector('.announcement-bar').offsetHeight;
  var headerHeight = header.offsetHeight;
  window.addEventListener('scroll', function () {
    if (window.scrollY > infoBarHeight) {
      if (!header.classList.contains('fixed')) {
        header.classList.add('fixed');
        header.style.top = "-".concat(headerHeight, "px");
        setTimeout(function () {
          header.style.top = '0';
        }, 0);
      }
    } else {
      if (header.classList.contains('fixed')) {
        header.classList.remove('fixed');
      }
    }
  });
});

// Toggle function
var toggleInit = document.querySelectorAll('.toggle-init');
toggleInit.forEach(function (link) {
  if (link.dataset.toggleListenerAttached) {
    return;
  }
  link.dataset.toggleListenerAttached = 'true';
  link.addEventListener('click', function (event) {
    event.preventDefault();
    link.classList.toggle('active');
    var nextContainer = link.nextElementSibling;
    while (nextContainer) {
      if (nextContainer.classList.contains('toggle-container')) {
        nextContainer.classList.toggle('hidden');
        break;
      }
      nextContainer = nextContainer.nextElementSibling;
    }
  });
});

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgracewindale"] = self["webpackChunkgracewindale"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/js/app.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/scss/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;